import { useCallback, useRef } from 'react';

type Unsubscribe = () => void;
type Subscribe<T> = (callback: T) => Unsubscribe;

export function useSubscribe<T extends (...args: any[]) => void>() {
  const subscribers = useRef<T[]>([]);

  const subscribe: Subscribe<T> = useCallback((callback: T) => {
    subscribers.current = [...subscribers.current, callback];
    return () => {
      subscribers.current = subscribers.current.filter(sub => sub !== callback);
    };
  }, []);

  const fireEvents = useCallback((...args: Parameters<T>) => {
    subscribers.current.forEach(callback => callback(...args));
  }, []) as T;

  return [fireEvents, subscribe] as const;
}
